import { render, staticRenderFns } from "./mobile-drawer.vue?vue&type=template&id=70f16740&scoped=true&lang=pug"
import script from "./mobile-drawer.vue?vue&type=script&lang=js"
export * from "./mobile-drawer.vue?vue&type=script&lang=js"
import style0 from "./mobile-drawer.vue?vue&type=style&index=0&id=70f16740&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f16740",
  null
  
)

export default component.exports